import * as React from 'react';

const De24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#F6D928", d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2H3z" }), /* @__PURE__ */ React.createElement("path", { fill: "#E1001F", d: "M3 14h18v-4H3z" }), /* @__PURE__ */ React.createElement("path", { fill: "#000", d: "M3 10h18V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z" }));
De24.Size = 24;
De24.Title = "De";

export { De24 as default };
